// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhm_a bia_h","Menu__offsetParent":"bhm_b bia_bj","Menu__trigger--shadowed":"bhm_c"};